import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
export default function withColumnWidth(Cell) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(CellWithColumnWidth, _Component);

    var _super = _createSuper(CellWithColumnWidth);

    function CellWithColumnWidth() {
      _classCallCheck(this, CellWithColumnWidth);

      return _super.apply(this, arguments);
    }

    _createClass(CellWithColumnWidth, [{
      key: "UNSAFE_componentWillMount",
      value: function UNSAFE_componentWillMount() {
        this.setColumnWidth(this.props.width);
      }
    }, {
      key: "setColumnWidth",
      value: function setColumnWidth(width) {
        if (width !== undefined) {
          this.context.tableTree.setColumnWidth(this.props.columnIndex, width);
        }
      }
    }, {
      key: "UNSAFE_componentWillReceiveProps",
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        this.setColumnWidth(nextProps.width);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            width = _this$props.width,
            columnIndex = _this$props.columnIndex;
        var columnWidth = width !== null && width !== undefined ? width : this.context.tableTree.getColumnWidth(columnIndex);
        return /*#__PURE__*/React.createElement(Cell, _extends({}, this.props, {
          width: columnWidth
        }));
      }
    }]);

    return CellWithColumnWidth;
  }(Component), _defineProperty(_class, "contextTypes", {
    tableTree: PropTypes.object.isRequired
  }), _temp;
}